export default {
    setMeditations(state, meditations) {
        state.meditations = meditations;
    },
    setError(state, error) {
        state.error = error.toString();
    },
    setMeditation(state, meditation) {
        state.meditation = meditation;
    },
};
